export default {"src":"/_next/static/media/crystal_ball.15fb7489.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};